import * as React from "react";
import RssFeedButton from "../../RenderComponents/RssFeedButton";
import ShareButton from "./ShareButton";

interface IProps {
    config: any;
    post: any;
}

export default ({ config, post }: IProps) => {
    return (
        <>
            {post ? <div className="CMS_e_row">
                <ShareButton />&nbsp;
                <RssFeedButton config={config} />
            </div> : null}
        </>
    );
};
